import { formatEuro } from '../../helpers/formatCurrency';
import { Resource as ResourceType } from '../types';

export const invoice: ResourceType = {
  name: 'invoices',
  label: 'resource.invoices.label',
  hideResource: false,
  subMenu: {
    name: 'invoices',
    items: [
      {
        key: 'client_invoices',
        path: 'client_invoices',
        label: 'resource.client_invoices.sub_menu.label',
      },
      {
        key: 'expert_invoices',
        path: 'expert_invoices',
        label: 'resource.expert_invoices.sub_menu.label',
      },
    ],
  },
  attributes: [
    {
      key: 'id',
      label: 'resource.invoices.field.id.label',
      type: 'text',
    },
    {
      key: 'company_name',
      label: 'resource.invoices.field.company_name.label',
      type: 'text',
    },
    {
      key: 'total_ttc',
      label: 'resource.invoices.field.total_ttc.label',
      type: 'number',
    },
    {
      key: 'total_ht',
      label: 'resource.invoices.field.total_ht.label',
      type: 'number',
    },
    {
      key: 'remaining_amount',
      label: 'remaining.amount.owed.label',
      type: 'number',
    },
    {
      key: 'guid',
      label: 'resource.invoices.field.guid.label',
      type: 'text',
    },
    {
      key: 'pdfs',
      label: 'resource.invoices.field.pdfs.label',
      type: 'buttons',
    },
    {
      key: 'contract_milestone_id',
      label: 'resource.invoices.field.contract_milestone_id.label',
      type: 'reference',
      reference: 'contract_milestones',
    },
    {
      key: 'credit_note_id',
      label: 'resource.invoices.field.credit_note_id.label',
      type: 'reference',
      reference: 'credit_notes',
    },
    {
      key: 'due_date',
      label: 'resource.invoices.field.due_date.label',
      type: 'date',
    },
    {
      key: 'payment_date',
      label: 'resource.invoices.field.payment_date.label',
      type: 'date',
    },
    {
      key: 'user_kind',
      label: 'resource.invoices.field.user_kind.label',
      type: 'select',
      choices: [
        {
          id: 'expert',
          name: 'resource.invoices.field.user_kind.choices.expert.label',
        },
        {
          id: 'client',
          name: 'resource.invoices.field.user_kind.choices.client.label',
        },
      ],
    },
    {
      key: 'status',
      label: 'resource.invoices.field.status.label',
      type: 'selectChoice',
    },
    {
      key: 'factor',
      label: 'resource.proposals.field.factor.label',
      type: 'boolean',
    },
    {
      key: 'client_platform_deposit',
      label: 'resource.invoices.field.client_platform_deposit.label',
      type: 'boolean',
    },
    {
      key: 'created_at',
      label: 'resource.invoices.field.created_at.label',
      type: 'date',
    },
    {
      key: 'updated_at',
      label: 'resource.invoices.field.updated_at.label',
      type: 'date',
    },
    {
      key: 'mission_id',
      label: 'resource.invoices.field.mission_id.label',
      type: 'reference',
      reference: 'missions',
    },
    {
      key: 'proposal_id',
      label: 'resource.invoices.field.proposal_id.label',
      type: 'reference',
      reference: 'proposals',
    },
    {
      key: 'mission_name',
      label: 'resource.invoices.field.mission_id.label',
      type: 'text',
    },
    {
      key: 'company_id',
      label: 'resource.invoices.field.client_company_id.label',
      type: 'reference',
      reference: 'companies',
    },
    {
      key: 'category',
      label: 'resource.invoices.field.category.label',
      type: 'select',
      choices: [
        {
          id: 'MATCH',
          name: 'resource.invoices.field.category.choices.match.label',
        },
        {
          id: 'MB',
          name: 'resource.invoices.field.category.choices.mb.label',
        },
        {
          id: 'SEO',
          name: 'resource.invoices.field.category.choices.seo.label',
        },
      ],
    },
    {
      key: 'corporate_name',
      label: 'resource.legal_informations.field.corporate_name.label',
      type: 'text',
    },
    {
      key: 'billing_mail',
      label: 'resource.users.field.email.label',
      type: 'email',
    },
    {
      key: 'billing_street',
      label: 'resource.legal_informations.field.billing_street.label',
      type: 'text',
    },
    {
      key: 'billing_zipcode',
      label: 'resource.legal_informations.field.zipcode.label',
      type: 'text',
    },
    {
      key: 'billing_city',
      label: 'resource.legal_informations.field.city.label',
      type: 'text',
    },
    {
      key: 'billing_country',
      label: 'resource.legal_informations.field.country.label',
      type: 'text',
    },
    {
      key: 'vat_number',
      label: 'resource.legal_informations.field.vat_number.label',
      type: 'text',
    },
    {
      key: 'purchase_order',
      label: 'resource.invoices.field.purchase_order.label',
      type: 'text',
    },
    {
      key: 'project_name',
      label: 'resource.invoices.field.project_name.label',
      type: 'text',
    },
    {
      key: 'manual_client_active',
      label: 'resource.invoices.field.manual_client_active.label',
      type: 'boolean',
    },
    {
      key: 'candidacy_company_id',
      type: 'reference',
      reference: 'users',
    },
    {
      key: 'client_owner_id',
      type: 'reference',
      reference: 'users',
    },
    {
      key: 'client_company_id',
      type: 'reference',
      reference: 'companies',
    },
    {
      key: 'expert_id',
      type: 'reference',
      reference: 'users',
    },
    {
      key: 'expert_company_id',
      type: 'reference',
      reference: 'companies',
    },
    {
      key: 'contract_milestone',
      type: 'object',
      shape: [
        {
          key: 'payment_period',
          label: 'resource.contract_milestones.field.payment_period.label',
          type: 'select',
          choices: [
            {
              id: 'forty_five_days',
              name: 'resource.contract_milestones.field.payment_period.choices.forty_five_days_x.label',
            },
            {
              id: 'thirty_days',
              name: 'resource.contract_milestones.field.payment_period.choices.thirty_days_x.label',
            },
            {
              id: 'fifteen_days',
              name: 'resource.contract_milestones.field.payment_period.choices.fifteen_days_x.label',
            },
            {
              id: 'seventy_two_hours',
              name: 'resource.contract_milestones.field.payment_period.choices.seventy_two_hours_x.label',
            },
            {
              id: 'payment_client',
              name: 'resource.contract_milestones.field.payment_period.choices.payment_client.label',
            },
            {
              id: 'fifteen_working_days',
              name: 'resource.contract_milestones.field.payment_period.choices.fifteen_working_days.label',
            },
            {
              id: 'five_working_days',
              name: 'resource.contract_milestones.field.payment_period.choices.five_working_days.label',
            },
            {
              id: 'immediate',
              name: 'resource.contract_milestones.field.payment_period.choices.immediate.label',
            },
          ],
        },
        {
          key: 'discount',
          label: 'resource.proposals.field.discount.label',
          type: 'number',
        },
        {
          key: 'vat',
          label: 'resource.contract_milestones.field.vat.label',
          type: 'number',
        },
        {
          key: 'professional_indemnity_percentage',
          label:
            'resource.proposals.field.professional_indemnity_percentage.label',
          type: 'number',
        },
        {
          key: 'professional_indemnity',
          label: 'resource.proposals.field.professional_indemnity.label',
          type: 'boolean',
        },
        {
          key: 'total_charges',
          type: 'number',
        },
        {
          key: 'admin_total_charges',
          type: 'number',
        },
      ],
    },
    {
      key: 'billing_date',
      type: 'date',
      label: 'resource.invoices.field.invoices_at.label',
    },
    {
      key: 'proforma_pdfs',
      label: 'resource.invoices.field.proforma_pdfs.label',
      type: 'buttons',
    },
    {
      key: 'proforma_or_pdfs',
      label: 'resource.invoices.field.pdfs.label',
      type: 'buttons',
    },
    {
      key: 'payment_terms',
      label: 'resource.legal_informations.field.payment_terms.label',
      type: 'wysiwyg',
    },
    {
      key: 'days_delayed',
      label: 'resource.legal_informations.field.days_delayed.label',
      type: 'number',
    },
    {
      key: 'end_month',
      label: 'resource.legal_informations.field.end_month.label',
      type: 'boolean',
    },
    {
      key: 'precise_date',
      label: 'resource.legal_informations.field.precise_date.label',
      type: 'number',
    },
    {
      key: 'attachments',
      label: '',
      type: 'file',
    },
    {
      key: 'expert_invoice_id',
      type: 'reference',
      reference: 'invoices',
    },
    {
      key: 'client_invoice_id',
      type: 'reference',
      reference: 'invoices',
    },
    {
      key: 'owner_id',
      type: 'reference',
      reference: 'users',
    },
  ],
  pages: {
    list: {
      hasEditButton: true,
      search: {
        enabled: true,
        label: 'filter.search.label',
      },
      filters: [
        {
          source: 'status',
          type: 'multipleSelect',
          optionsFilter: {
            className: 'multipleSelectFilter',
          },
        },
        {
          name: 'client_company_id',
          type: 'reference',
          reference: 'companies',
          label: 'resource.invoices.field.client_company_id.label',
          filter: { user_kind: 'client' },
          child: {
            type: 'autocomplete',
            optionText: 'name',
            options: {
              perPage: 10,
              allowEmpty: false,
            },
          },
        },
        {
          name: 'company_id',
          type: 'reference',
          reference: 'companies',
          label: 'resource.invoices.field.company_id.label',
          filter: { user_kind: 'expert' },
          child: {
            type: 'autocomplete',
            optionText: 'name',
            options: {
              perPage: 10,
              allowEmpty: false,
            },
          },
        },
        {
          source: 'billing_date',
          type: 'dateRange',
          label: 'resource.invoices.field.invoices_at.label',
        },
        {
          source: 'payment_date',
          type: 'dateRange',
          label: 'resource.invoices.field.payment_date.label',
        },
        {
          source: 'client_platform_deposit',
          type: 'boolean',
          label: 'resource.invoices.field.client_platform_deposit.label',
        },
      ],
      fields: [
        {
          source: 'guid',
        },
        {
          source: 'company_id',
          type: 'company',
          label: 'resource.invoices.field.company_name.label',
        },
        {
          source: 'client_owner_id',
          label: 'resource.invoices.field.client_company_id.label',
          child: {
            source: 'users.full_name',
          },
        },
        {
          source: 'corporate_name',
        },
        {
          source: 'billing_mail',
        },
        {
          source: 'status',
        },
        {
          source: 'billing_date',
        },
        {
          source: 'payment_date',
        },
        {
          source: 'due_date',
        },
        {
          source: 'total_ht',
        },
        {
          source: 'total_ttc',
        },
        { source: 'remaining_amount' },
        {
          source: 'contract_milestone_id',
          child: {
            source: 'contract_milestones.title',
          },
        },
        {
          source: 'mission_id',
          child: {
            source: 'missions.name',
          },
        },
        {
          source: 'proposal_id',
          child: {
            source: 'proposals.guid',
          },
        },
        {
          source: 'attachments',
          type: 'buttons',
          extensions: [
            {
              key: 'attachmentsFiles',
            },
          ],
        },
        {
          source: 'created_at',
        },
      ],
      bulkActionButtons: [
        {
          name: 'validate',
          type: 'update',
          label: 'resource.invoices.bulk_action_buttons.validate.label',
          values: {
            validated: true,
          },
          blockIf: {
            conditions: [{ property: 'status', op: 'eq', value: 'draft' }],
            errorKey: 'invoice.errors.draft_must_be_emitted_before_paid',
          },
        },
      ],
    },
    edit: {
      singleRedirect: {
        page: 'edit',
        basePath: '/invoices',
        recordId: 'id',
      },
      actions: [
        {
          name: 'emit',
          checkUnsavedChanges: true,
          type: 'modal',
          httpMethod: 'update',
          extraUrl: '/emit',
          label: 'action.validate_invoice.label',
          withConfirmation: true,
          values: {},
          confirmation: {
            title: 'action.validate_invoice.modal.title',
            content: 'action.validate_invoice.modal.content',
          },
          modal: {
            inputs: {},
          },
          rules: {
            hide: [
              {
                property: 'status',
                op: 'neq',
                value: 'draft',
              },
            ],
          },
        },
        {
          name: 'cancel_draft',
          type: 'modal',
          label: 'action.cancel_draft.label',
          extraUrl: '/cancel',
          withConfirmation: true,
          values: { status: 'cancelled' },
          confirmation: {
            title: 'action.cancel_draft.modal.title',
            content: 'action.cancel_draft.modal.content',
          },
          modal: {
            inputs: {},
          },
          rules: {
            hide: [
              {
                property: 'user_kind',
                op: 'eq',
                value: 'expert',
              },
              {
                property: 'status',
                op: 'neq',
                value: 'draft',
              },
            ],
          },
        },
        {
          name: 'cancel',
          type: 'modal',
          label: 'action.cancel_draft.label',
          extraUrl: '/cancel',
          withConfirmation: true,
          values: { status: 'cancelled' },
          confirmation: {
            title: 'action.cancel.modal.title',
            content: 'action.cancel.modal.content',
          },
          modal: {
            inputs: {},
          },
          rules: {
            hide: [
              {
                property: 'user_kind',
                op: 'eq',
                value: 'expert',
              },
              {
                property: 'status',
                op: 'eq',
                value: 'cancelled',
              },
              {
                property: 'status',
                op: 'eq',
                value: 'draft',
              },
            ],
          },
        },
        {
          name: 'resource.invoices.bulk_action_buttons.generate_a_new_invoice.label',
          type: 'modal',
          httpMethod: 'create',
          extraUrl: '/create',
          label:
            'resource.invoices.bulk_action_buttons.generate_a_new_invoice.label',
          withConfirmation: true,
          values: { createInvoice: 'true' },
          confirmation: {
            title: 'action.generate_a_new_invoice.modal.title',
            content: 'action.generate_a_new_invoice.modal.content',
          },
          disabled: [{ property: 'status', op: 'neq', value: 'cancelled' }],
          modal: {
            inputs: {},
          },
          rules: {
            hide: [
              {
                property: 'user_kind',
                op: 'eq',
                value: 'expert',
              },
              {
                property: 'contract_milestone_id',
                op: 'absent',
              },
            ],
          },
        },
      ],
      left: {
        tabs: [
          {
            key: 'information',
            title: 'resource.invoices.tab.information.title',
            sections: [
              {
                key: 'details',
                title: 'resource.invoices.section.details.title',
                layout: [
                  ['guid', 'category'],
                  ['status', 'vat'],
                  ['factor'],
                  ['client_platform_deposit'],
                  ['user_kind'],
                  ['total_ht', 'total_ttc'],
                  ['billing_date'],
                  ['contract_milestone.vat'],
                  ['due_date'],
                  ['payment_date'],
                  ['purchase_order'],
                  [
                    'contract_milestone.discount',
                    'contract_milestone.payment_period',
                  ],
                  [
                    'contract_milestone.professional_indemnity',
                    'contract_milestone.professional_indemnity_percentage',
                  ],
                ],
                inputs: {
                  guid: {
                    width: 6,
                    rules: {
                      disabled: [
                        {
                          property: 'user_kind',
                          op: 'neq',
                          value: 'expert',
                        },
                      ],
                    },
                    label: 'resource.invoices.field.guid_name.label',
                  },
                  category: {
                    width: 6,
                    disabled: true,
                    rules: {
                      hide: [
                        {
                          property: 'contract_milestone_id',
                          op: 'present',
                        },
                      ],
                    },
                  },
                  status: {
                    width: 6,
                    rules: {
                      disabled: [
                        {
                          property: 'status',
                          op: 'eq',
                          value: 'draft',
                        },
                        {
                          property: 'status',
                          op: 'eq',
                          value: 'cancelled',
                        },
                        {
                          property: 'status',
                          op: 'eq',
                          value: 'proforma',
                        },
                      ],
                    },
                  },
                  vat: {
                    width: 6,
                    label: 'payment.taxes.tva.label',
                    type: 'number',
                    initialValue: 20,
                    rules: {
                      disabled: [
                        {
                          property: 'status',
                          op: 'neq',
                          value: 'draft',
                        },
                      ],
                      hide: [
                        {
                          property: 'contract_milestone_id',
                          op: 'present',
                        },
                      ],
                    },
                  },
                  factor: {
                    width: 6,
                    rules: {
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'expert',
                        },
                        {
                          property: 'status',
                          op: 'eq',
                          value: 'draft',
                        },
                      ],
                    },
                  },
                  client_platform_deposit: {
                    width: 6,
                    rules: {
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'expert',
                        },
                        {
                          property: 'status',
                          op: 'eq',
                          value: 'draft',
                        },
                      ],
                    },
                  },
                  user_kind: {
                    disabled: true,
                  },
                  total_ht: {
                    width: 6,
                    label: 'payment.amount.ht',
                    disabled: true,
                    rules: {
                      hide: [
                        {
                          property: 'contract_milestone_id',
                          op: 'absent',
                        },
                      ],
                    },
                  },
                  total_ttc: {
                    width: 6,
                    label: 'invoice.amount',
                    disabled: true,
                    rules: {
                      hide: [
                        {
                          property: 'contract_milestone_id',
                          op: 'absent',
                        },
                      ],
                    },
                  },
                  billing_date: {
                    validators: [{ key: 'required' }],
                    rules: {
                      disabled: [
                        {
                          property: 'status',
                          op: 'neq',
                          value: 'draft',
                        },
                      ],
                    },
                  },
                  'contract_milestone.vat': {
                    width: 12,
                    validators: [
                      {
                        key: 'required',
                      },
                    ],
                    rules: {
                      disabled: [
                        {
                          property: 'status',
                          op: 'neq',
                          value: 'draft',
                        },
                      ],
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'client',
                        },
                      ],
                    },
                  },
                  due_date: {
                    validators: [{ key: 'required' }],
                    rules: {
                      disabled: [
                        {
                          property: 'status',
                          op: 'neq',
                          value: 'draft',
                        },
                      ],
                    },
                  },
                  payment_date: {},
                  purchase_order: {
                    rules: {
                      disabled: [
                        {
                          property: 'status',
                          op: 'neq',
                          value: 'draft',
                        },
                      ],
                    },
                  },
                  'contract_milestone.discount': {
                    width: 6,
                    extensions: [
                      {
                        key: 'multiplyByHundredInput',
                      },
                    ],
                    validators: [
                      {
                        key: 'required',
                      },
                      {
                        key: 'minValue',
                        value: 0,
                      },
                      {
                        key: 'maxValue',
                        value: 100,
                      },
                    ],
                    min: 0,
                    max: 100,
                    step: 0.01,
                    rules: {
                      disabled: [
                        {
                          property: 'status',
                          op: 'neq',
                          value: 'draft',
                        },
                      ],
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'client',
                        },
                      ],
                    },
                  },
                  'contract_milestone.payment_period': {
                    width: 6,
                    extensions: [
                      {
                        key: 'disabledByDate',
                      },
                    ],
                    validators: [
                      {
                        key: 'required',
                      },
                    ],
                    rules: {
                      disabled: [
                        {
                          property: 'status',
                          op: 'neq',
                          value: 'draft',
                        },
                      ],
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'client',
                        },
                      ],
                    },
                  },
                  'contract_milestone.professional_indemnity': {
                    width: 6,
                    initialValue: false,
                    validators: [
                      {
                        key: 'required',
                      },
                    ],
                    rules: {
                      disabled: [
                        {
                          property: 'status',
                          op: 'neq',
                          value: 'draft',
                        },
                      ],
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'client',
                        },
                      ],
                    },
                  },
                  'contract_milestone.professional_indemnity_percentage': {
                    width: 6,
                    validators: [
                      {
                        key: 'required',
                        rules: [
                          {
                            property:
                              'contract_milestone.professional_indemnity',
                            op: 'eq',
                            value: true,
                          },
                        ],
                      },
                      {
                        key: 'minValue',
                        value: 0,
                      },
                      {
                        key: 'maxValue',
                        value: 100,
                      },
                    ],
                    min: 0,
                    max: 100,
                    step: 0.01,
                    rules: {
                      disabled: [
                        {
                          property: 'contract_milestone.professional_indemnity',
                          op: 'eq',
                          value: false,
                        },
                        {
                          property: 'status',
                          op: 'neq',
                          value: 'draft',
                        },
                      ],
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'client',
                        },
                      ],
                    },
                    extensions: [
                      {
                        key: 'multiplyByHundredInput',
                      },
                    ],
                  },
                },
              },
              {
                key: 'billing_conditions',
                title:
                  'resource.legal_informations.section.billing_contact.title',
                layout: [
                  ['payment_terms'],
                  ['days_delayed', 'end_month'],
                  ['precise_date'],
                ],
                rules: {
                  hide: [
                    {
                      property: 'contract_milestone_id',
                      op: 'present',
                    },
                  ],
                },
                fields: {
                  payment_terms: { addLabel: true },
                  days_delayed: { addLabel: true },
                  end_month: { addLabel: true, type: 'boolean' },
                  precise_date: { addLabel: true },
                },
                inputs: {
                  payment_terms: {
                    width: 12,
                    validators: [{ key: 'required' }],
                    rules: {
                      disabled: [
                        {
                          property: 'status',
                          op: 'neq',
                          value: 'draft',
                        },
                      ],
                    },
                  },
                  days_delayed: {
                    width: 6,
                    validators: [{ key: 'required' }],
                    rules: {
                      disabled: [
                        {
                          property: 'status',
                          op: 'neq',
                          value: 'draft',
                        },
                      ],
                    },
                  },
                  end_month: {
                    width: 6,
                    rules: {
                      disabled: [
                        {
                          property: 'status',
                          op: 'neq',
                          value: 'draft',
                        },
                      ],
                    },
                  },
                  precise_date: {
                    width: 6,
                    validators: [
                      { key: 'minValue', value: 0 },
                      { key: 'maxValue', value: 31 },
                    ],
                    rules: {
                      disabled: [
                        {
                          property: 'end_month',
                          op: 'eq',
                          value: false,
                        },
                        {
                          property: 'status',
                          op: 'neq',
                          value: 'draft',
                        },
                      ],
                    },
                  },
                },
              },
              {
                key: 'payments',
                title: 'resource.invoices.section.payments.title',
                layout: [['remaining_amount']],
                fields: {
                  remaining_amount: {
                    addLabel: true,
                    title: 'remaining.amount.owed.label',
                    source: 'remaining_amount',
                    type: 'number',
                    format: formatEuro,
                  },
                },
                rules: {
                  hide: [{ property: 'user_kind', op: 'eq', value: 'client' }],
                },
                inputs: {},
              },
              {
                key: '',
                title: '',
                layout: [],
                relatedRecord: {
                  recordToCreate: 'payments',
                  addRecordLabel: 'action.add_payment_button.title',
                  modalTitle: 'action.add_payment_button.title',
                  filter_attribute: 'invoice_id',
                  filter_resource: 'invoice',
                  inputs: {
                    amount: {
                      type: 'number',
                      width: 6,
                      showEuro: true,
                      validators: [
                        { key: 'required' },
                        { key: 'minValue', value: 0 },
                      ],
                    },
                    partial_payment_date: {
                      type: 'date',
                      width: 6,
                      validators: [{ key: 'required' }],
                    },
                  },
                },
                rules: {
                  hide: [{ property: 'user_kind', op: 'eq', value: 'client' }],
                },
                inputs: {},
              },
              {
                key: 'charges',
                title: 'resource.charges.label',
                layout: [],
                rules: {
                  hide: [
                    {
                      property: 'contract_milestone_id',
                      op: 'present',
                    },
                  ],
                },
                inputs: {},
                relatedRecord: {
                  recordToCreate: 'charges',
                  addRecordLabel: 'action.add_related_charges',
                  modalTitle: 'modal.contract_milestone.add_charges',
                  filter_resource: 'invoice',
                  filter_attribute: 'id',
                  validators: [{ key: 'required' }],
                  inputs: {
                    charge_title: {
                      width: 6,
                    },
                    unit: {
                      width: 6,
                    },
                    admin_quantity: {
                      label: 'resource.charges.field.admin_quantity.label',
                      width: 6,
                    },
                    admin_cost_per_unit: {
                      label: 'resource.charges.field.admin_cost_per_unit.label',
                      width: 6,
                    },
                  },
                },
              },
              {
                key: 'download',
                title: 'resource.invoices.section.download.title',
                layout: [['pdfs'], ['attachments'], ['proforma_pdfs']],
                inputs: {
                  attachments: {
                    validators: [{ key: 'required' }],
                  },
                },
                fields: {
                  pdfs: {
                    addLabel: true,
                    extensions: [
                      {
                        key: 'multipleLangFiles',
                      },
                    ],
                  },
                  proforma_pdfs: {
                    addLabel: true,
                    extensions: [
                      {
                        key: 'multipleLangFiles',
                      },
                    ],
                    rules: {
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'client',
                        },
                      ],
                    },
                  },
                },
              },
            ],
          },
        ],
      },
      right: [
        {
          sections: [
            {
              key: 'details',
              title: 'resource.invoices.section.infos.title',
              layout: [['id'], ['category'], ['created_at'], ['updated_at']],
              inputs: {
                id: {
                  disabled: true,
                },
                category: {
                  disabled: true,
                },
                updated_at: {
                  disabled: true,
                },
                created_at: {
                  disabled: true,
                },
              },
              fields: {},
            },
          ],
        },
        {
          sections: [
            {
              key: 'links',
              title: 'resource.invoices.section.links.title',
              layout: [
                ['contract_milestone_id'],
                ['credit_note_id'],
                ['mission_id'],
                ['proposal_id'],
                ['candidacy_company_id'],
                ['owner_id'],
                ['expert_company_id'],
                ['leader_company_name'],
                ['client_owner_id'],
                ['client_company_name'],
                ['corporate_name'],
                ['billing_mail'],
              ],
              inputs: {},
              fields: {
                contract_milestone_id: {
                  addLabel: true,
                  child: { source: 'contract_milestones.title', type: 'text' },
                  rules: {
                    hide: [{ property: 'contract_milestone_id', op: 'absent' }],
                  },
                },
                credit_note_id: {
                  addLabel: true,
                  child: { source: 'credit_notes.guid', type: 'text' },
                  rules: {
                    hide: [{ property: 'credit_note_id', op: 'absent' }],
                  },
                },
                mission_id: {
                  addLabel: true,
                  label: 'resource.invoices.field.mission_id.label',
                  source: 'mission_id',
                  child: { type: 'text', source: 'missions.name' },
                  rules: {
                    hide: [{ property: 'mission_id', op: 'absent' }],
                  },
                },
                proposal_id: {
                  addLabel: true,
                  source: 'proposal_id',
                  label: 'resource.invoices.field.proposal_id.label',
                  child: { type: 'text', source: 'proposals.guid' },
                  rules: {
                    hide: [{ property: 'proposal_id', op: 'absent' }],
                  },
                },
                candidacy_company_id: {
                  addLabel: true,
                  source: 'owner_id',
                  label: 'resource.proposals.field.candidacy_owner_name.label',
                  child: { type: 'text', source: 'users.full_name' },
                  rules: {
                    hide: [{ property: 'candidacy_company_id', op: 'absent' }],
                  },
                },
                leader_company_name: {
                  addLabel: true,
                  link: false,
                  source: 'owner_id',
                  label: 'resource.users.field.company_name_profile.label',
                  child: { type: 'text', source: 'users.company_name' },
                  rules: {
                    hide: [{ property: 'candidacy_company_id', op: 'absent' }],
                  },
                },
                client_owner_id: {
                  addLabel: true,
                  label: 'resource.candidacies.field.company_name.label',
                  child: { type: 'text', source: 'users.full_name' },
                  rules: {
                    hide: [{ property: 'client_owner_id', op: 'absent' }],
                  },
                },
                client_company_name: {
                  addLabel: true,
                  link: false,
                  source: 'client_owner_id',
                  label: 'resource.missions.field.company_id.label',
                  child: { type: 'text', source: 'users.company_name' },
                  rules: {
                    hide: [{ property: 'client_owner_id', op: 'absent' }],
                  },
                },
                corporate_name: {
                  addLabel: true,
                  label:
                    'resource.legal_informations.field.corporate_name.label',
                  rules: {
                    hide: [{ property: 'corporate_name', op: 'absent' }],
                  },
                },
                billing_mail: {
                  addLabel: true,
                  label: 'resource.users.field.email.label',
                  rules: {
                    hide: [{ property: 'billing_mail', op: 'absent' }],
                  },
                },
              },
            },
          ],
        },
        {
          sections: [
            {
              key: 'history',
              title: 'resource.companies.section.history.title',
              layout: [],
              inputs: {},
              history: true,
              filterResource: 'invoices',
              filterAttribute: 'id',
            },
          ],
        },
      ],
    },
    create: {
      left: {
        tabs: [
          {
            key: 'information',
            title: 'resource.invoices.tab.information.title',
            sections: [
              {
                key: 'client_selection',
                title: 'resource.invoices.tab.information.title',
                layout: [
                  ['company_id', 'user_kind'],
                  ['manual_client_active'],
                  ['corporate_name'],
                  ['billing_mail'],
                  ['billing_street'],
                  ['billing_zipcode', 'billing_city'],
                  ['billing_country', 'vat_number'],
                ],
                inputs: {
                  user_kind: {
                    type: 'select',
                    initialValue: 'client',
                    rules: {
                      hide: [{ property: 'user_kind', op: 'present' }],
                    },
                  },
                  company_id: {
                    type: 'reference',
                    reference: 'companies',
                    filter: { user_kind: 'client' },
                    label: 'resource.invoices.field.client_company_id.label',
                    child: {
                      type: 'autocomplete',
                      optionText: 'name',
                      extensions: [{ key: 'manualClientChoice' }],
                      options: {
                        perPage: 50,
                        allowEmpty: true,
                        resettable: true,
                        clearAlwaysVisible: true,
                      },
                    },
                  },
                  manual_client_active: {
                    initialValue: false,
                    type: 'boolean',
                    rules: {
                      hide: [
                        {
                          property: 'manual_client_active',
                          op: 'neq',
                          value: 'force_hide',
                        },
                      ],
                    },
                  },
                  corporate_name: {
                    validators: [
                      {
                        key: 'required',
                        rules: [
                          {
                            property: 'manual_client_active',
                            op: 'eq',
                            value: true,
                          },
                        ],
                      },
                    ],
                    rules: {
                      hide: [
                        {
                          property: 'company_id',
                          op: 'absent',
                          value: null,
                        },
                      ],
                    },
                  },
                  billing_mail: {
                    type: 'email',
                    validators: [
                      {
                        key: 'required',
                        rules: [
                          {
                            property: 'manual_client_active',
                            op: 'eq',
                            value: true,
                          },
                        ],
                      },
                    ],
                    rules: {
                      hide: [
                        {
                          property: 'company_id',
                          op: 'absent',
                          value: null,
                        },
                      ],
                    },
                  },
                  billing_street: {
                    validators: [
                      {
                        key: 'required',
                        rules: [
                          {
                            property: 'manual_client_active',
                            op: 'eq',
                            value: true,
                          },
                        ],
                      },
                    ],
                    rules: {
                      hide: [
                        {
                          property: 'company_id',
                          op: 'absent',
                          value: null,
                        },
                      ],
                    },
                  },
                  billing_zipcode: {
                    width: 6,
                    validators: [
                      {
                        key: 'required',
                        rules: [
                          {
                            property: 'manual_client_active',
                            op: 'eq',
                            value: true,
                          },
                        ],
                      },
                    ],
                    rules: {
                      hide: [
                        {
                          property: 'company_id',
                          op: 'absent',
                          value: null,
                        },
                      ],
                    },
                  },
                  billing_city: {
                    width: 6,
                    validators: [
                      {
                        key: 'required',
                        rules: [
                          {
                            property: 'manual_client_active',
                            op: 'eq',
                            value: true,
                          },
                        ],
                      },
                    ],
                    rules: {
                      hide: [
                        {
                          property: 'company_id',
                          op: 'absent',
                          value: null,
                        },
                      ],
                    },
                  },
                  billing_country: {
                    width: 6,
                    validators: [
                      {
                        key: 'required',
                        rules: [
                          {
                            property: 'manual_client_active',
                            op: 'eq',
                            value: true,
                          },
                        ],
                      },
                    ],
                    rules: {
                      hide: [
                        {
                          property: 'company_id',
                          op: 'absent',
                          value: null,
                        },
                      ],
                    },
                  },
                  vat_number: {
                    width: 6,
                    rules: {
                      hide: [
                        {
                          property: 'company_id',
                          op: 'absent',
                          value: null,
                        },
                      ],
                    },
                  },
                },
              },
              {
                key: 'details',
                title: 'resource.invoices.section.details.title',
                layout: [
                  ['category', 'guid'],
                  ['status', 'vat'],
                  ['factor', 'client_platform_deposit'],
                  ['billing_date', 'due_date'],
                  ['payment_date'],
                  ['purchase_order'],
                  ['project_name'],
                ],
                inputs: {
                  category: {
                    width: 6,
                    validators: [{ key: 'required' }],
                  },
                  guid: {
                    width: 6,
                    label: 'resource.invoices.field.guid_name.label',
                    disabled: true,
                    validators: [],
                  },
                  status: {
                    width: 6,
                    type: 'select',
                    initialValue: 'draft',
                    disabled: true,
                    choices: [
                      {
                        id: 'draft',
                        name: 'resource.invoices.field.status.choices.draft.label',
                      },
                      {
                        id: 'created',
                        name: 'resource.invoices.field.status.choices.created.label',
                      },
                      {
                        id: 'delayed',
                        name: 'resource.invoices.field.status.choices.delayed.label',
                      },
                      {
                        id: 'payed',
                        name: 'resource.invoices.field.status.choices.payed.label',
                      },
                    ],
                    validators: [{ key: 'required' }],
                  },
                  factor: { width: 6 },
                  client_platform_deposit: { width: 6 },
                  billing_date: {
                    width: 6,
                    type: 'date',
                    validators: [{ key: 'required' }],
                  },
                  due_date: {
                    width: 6,
                    type: 'date',
                    validators: [{ key: 'required' }],
                  },
                  payment_date: { type: 'date' },
                  purchase_order: { type: 'text' },
                  vat: {
                    width: 6,
                    label: 'payment.taxes.tva.label',
                    disabled: false,
                    type: 'number',
                    initialValue: 20,
                    max: 20,
                    min: 0,
                    validators: [{ key: 'required' }],
                  },
                },
              },
              {
                key: 'billing_conditions',
                title:
                  'resource.legal_informations.section.billing_contact.title',
                layout: [
                  ['payment_terms'],
                  ['days_delayed', 'end_month'],
                  ['precise_date'],
                ],
                inputs: {
                  payment_terms: {
                    width: 12,
                    validators: [{ key: 'required' }],
                  },
                  days_delayed: {
                    width: 6,
                    validators: [{ key: 'required' }],
                  },
                  end_month: {
                    width: 6,
                  },
                  precise_date: {
                    width: 6,
                    validators: [
                      { key: 'minValue', value: 0 },
                      { key: 'maxValue', value: 31 },
                    ],
                    rules: {
                      disabled: [
                        {
                          property: 'end_month',
                          op: 'eq',
                          value: false,
                        },
                      ],
                    },
                  },
                },
              },
              {
                key: 'charges',
                title: 'resource.milestones.tab.charges.title',
                layout: [],
                inputs: {},
                relatedRecord: {
                  recordToCreate: 'charges',
                  addRecordLabel: 'action.add_related_charges',
                  modalTitle: 'modal.contract_milestone.add_charges',
                  filter_attribute: 'id',
                  filter_resource: 'invoice',
                  validators: [{ key: 'required' }],
                  inputs: {
                    charge_title: {
                      validators: [{ key: 'required' }],
                      width: 6,
                    },
                    unit: {
                      validators: [{ key: 'required' }],
                      width: 6,
                    },
                    admin_quantity: {
                      label: 'resource.charges.field.admin_quantity.label',
                      validators: [
                        { key: 'required' },
                        { key: 'minValue', value: 0 },
                      ],
                      width: 6,
                      step: 0.5,
                    },
                    admin_cost_per_unit: {
                      label: 'resource.charges.field.admin_cost_per_unit.label',
                      validators: [
                        { key: 'required' },
                        { key: 'minValue', value: 0 },
                      ],
                      width: 6,
                    },
                  },
                },
              },
            ],
          },
        ],
      },
    },
  },
};
